<template>
    <NuxtLink class="flex col-span-6 md:col-span-2 justify-center block" to="/" aria-label="Home">          
        <Logo style="width:119px" class="mx-auto" :color="iconColor"/>
    </NuxtLink>    
</template>

<script setup>
import { IconLine } from '@tabler/icons-vue';
const Logo = defineAsyncComponent(() => import('@/components/Logo.vue'));


defineProps({
    
    iconColor: {
        type: String,
        required: true
    }
});

</script>
<style scoped>

    a{
        display:IconLine
    }
    
</style>

